export const contactValues = [
    { value: 'maitre-ouvrage', name: "Maître d'ouvrage" },
    { value: 'maitre-oeuvre', name: "Maître d'œuvre" },
    { value: 'bureau-etudes', name: "Bureau d'étude" },
    { value: 'particulier', name: 'Particulier' },
    { value: 'promoteur', name: 'Promoteur' },
    { value: 'payeur', name: 'Payeur' },
    { value: 'gardien', name: 'Gardien' },
    { value: 'gestionnaire', name: 'Gestionnaire' },
    { value: 'proprietaire', name: 'Propriétaire' },
    { value: 'locataire', name: 'Locataire' },
    { value: 'autre', name: 'Autre' },
];
